import type { ObjectBoxInfo, ViewEntity } from '@/engine/app/models/viewEntity/view.entity';
import { type IObjectViewModel, ObjectsKind } from '@/engine/app/interfaces';
import type { ViewsService } from '@/engine/app/Views.service';

export function addCustomCommissurePointsViewModels(
  view: ViewEntity,
  viewsService: ViewsService,
  pointViewModel: IObjectViewModel
): void {
  const additionalViews = _getAdditionalViewsByBoxKind(view, viewsService, ObjectsKind.CommissurePoints);
  view.addObject(pointViewModel);
  const newPointViewModel = pointViewModel.clone();
  newPointViewModel.setIsTunable(true);
  additionalViews.forEach((view) => {
    view.addObject(newPointViewModel.clone());
    view.addWorkflowIndication(pointViewModel.descriptor);
  });
  view.addObjectToBox(pointViewModel, ObjectsKind.CommissurePoints);
  view.addWorkflowIndication(pointViewModel.descriptor);
}

export function removeCustomCommissurePointsViewModels(
  view: ViewEntity,
  viewsService: ViewsService,
  pointViewModel: IObjectViewModel
): void {
  const additionalViews = _getAdditionalViewsByBoxKind(view, viewsService, ObjectsKind.CommissurePoints);
  additionalViews.forEach((view) => {
    view.removeByDescriptor(pointViewModel.descriptor);
    view.removeWorkflowIndication(pointViewModel.descriptor);
  });
  view.removeObject(pointViewModel);
  view.removeObjectFromBox(pointViewModel, ObjectsKind.CommissurePoints);
  view.removeWorkflowIndication(pointViewModel.descriptor);
}

function _getAdditionalViewsByBoxKind(
  view: ViewEntity,
  viewsService: ViewsService,
  kind: ObjectsKind
): Array<ViewEntity> {
  const additionalViewsDescriptors: Array<string> =
    view.getObjectBoxes().find((box: ObjectBoxInfo): boolean => box.kind === kind)?.details ?? [];
  const additionalViews = additionalViewsDescriptors
    .map((descriptor) => viewsService.getViewByDescriptor(descriptor))
    .filter((view) => view !== undefined);
  return additionalViews;
}
